import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChangePasswordTooltipComponent } from './change-password-tooltip.component';
import { FiChangePasswordTooltipItemComponent } from './change-password-tooltip-item.component';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiAppTextSharedModule } from '@fi-shared/app-text';

@NgModule({
    imports: [CommonModule, FiErrorMessageModule, FiAppTextSharedModule],
    declarations: [FiChangePasswordTooltipComponent, FiChangePasswordTooltipItemComponent],
    exports: [FiChangePasswordTooltipComponent],
})
export class FiChangePasswordTooltipModule {}
